// authApi.js
import { API_CONFIG} from "../../../utils/api-config";
import fetchWithAuth from "../../../utils/apiAthurization";

export const StoreLabRegistration = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/lab-registrations`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetLabRegistrations = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/lab-registrations`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "diagnosis/lab-registrations fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetLabRegistrationById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/lab-registrations/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateLabRegistration = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/lab-registrations/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteLabRegistration = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/diagnosis/lab-registrations/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};